import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./EmployeeLogin.css";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  Consultantlogin,
  verifyConsultantOtp,
} from "../../services/authService";
import LoginBg from "../../asseets/Loginbg.svg";
import NormalAlert from "../AlertComponent/NormalAlert";

const ConsultantLogin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);
  const [IsPasswordVisible, setIsPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOtpStep, setIsOtpStep] = useState(false);
  const [otpInput, setOtpInput] = useState("");

  // Captcha states
  const [captchaText, setCaptchaText] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");

  // Forget Password States
    const [isForgotPassword, setIsForgotPassword] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

  const generateCaptcha = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    const captcha = Array.from({ length: 6 }, () =>
      chars.charAt(Math.floor(Math.random() * chars.length))
    ).join("");

    setCaptchaText(captcha);
    setCaptchaAnswer(captcha);
    setCaptchaInput("");
  };

  useEffect(() => {
    const canvas = document.getElementById("consultantCaptchaCanvas");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#EAF4FF";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    if (!captchaText) return;

    // Random noisy lines
    for (let i = 0; i < 5; i++) {
      ctx.strokeStyle = `rgba(0, 70, 135, ${Math.random() * 0.5 + 0.3})`;
      ctx.beginPath();
      ctx.moveTo(Math.random() * 150, Math.random() * 45);
      ctx.lineTo(Math.random() * 150, Math.random() * 45);
      ctx.stroke();
    }

    // Text with rotation
    ctx.font = "bold 24px monospace";
    ctx.textBaseline = "middle";

    const xStart = 15;
    for (let i = 0; i < captchaText.length; i++) {
      const angle = (Math.random() - 0.5) * 0.4;
      ctx.save();
      ctx.translate(xStart + i * 20, 22);
      ctx.rotate(angle);
      ctx.fillStyle = `rgb(${50 + Math.random() * 100}, ${
        60 + Math.random() * 100
      }, ${120 + Math.random() * 100})`;
      ctx.fillText(captchaText[i], 0, 0);
      ctx.restore();
    }

    // Random dots
    for (let i = 0; i < 30; i++) {
      ctx.fillStyle = `rgba(0, 0, 0, ${Math.random() * 0.3})`;
      ctx.beginPath();
      ctx.arc(Math.random() * 150, Math.random() * 45, 1, 0, 2 * Math.PI);
      ctx.fill();
    }
  }, [captchaText]);

  useEffect(() => {
    generateCaptcha();
  }, []);

  // Login
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    const validationErrors = {};
    if (!email.trim()) validationErrors.email = "Email is required.";
    if (!password.trim()) {
      validationErrors.password = "Password is required.";
    } else if (!isStrongPassword(password)) {
      setAlert({
        type: "fail",
        message:
          "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.",
      });
      setLoading(false);
      return;
    }
    if (!captchaInput.trim())
      validationErrors.captchaInput = "Captcha is required.";
    else if (captchaInput.trim() !== captchaAnswer.trim()) {
      validationErrors.captchaInput =
        "Invalid captcha. Please enter the exact characters (case-sensitive).";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setLoading(false);
      return;
    }

    try {
      const response = await Consultantlogin(email, password);
      const data = response.data;

      if (data.status === "Success" && data.authUID) {
        Cookies.set("consultantAuthUID", data.authUID, {
          secure: true,
          sameSite: "Strict",
        });
        setIsOtpStep(true);
        setAlert({
          type: "success",
          message: "OTP sent to your email. Please verify it.",
        });
      } else {
        setAlert({ type: "fail", message: data.message || "Login failed." });
        generateCaptcha();
      }
    } catch (error) {
      setAlert({
        type: "fail",
        message: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  const isStrongPassword = (password) => {
    const strongPasswordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return strongPasswordRegex.test(password);
  };

  // Verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    const authUID = Cookies.get("consultantAuthUID");

    if (!otpInput.trim()) {
      setAlert({ type: "fail", message: "Please enter OTP." });
      return;
    }

    try {
      const response = await verifyConsultantOtp(otpInput.trim(), authUID);
      const data = response.data;

      if (data.status === "Success" && data.userDetails?.token) {
        const { token } = data.userDetails;
        Cookies.set("ConsultantToken", token, {
          secure: true,
          sameSite: "Strict",
        });
        Cookies.set("username", email.split("@")[0], {
          secure: true,
          sameSite: "Strict",
        });

        setAlert({ type: "success", message: "OTP verified successfully!" });
        setTimeout(() => navigate("/Consultant/Dashboard"), 1500);
      } else {
        setAlert({
          type: "fail",
          message: data.message || "Invalid OTP. Please try again.",
        });
      }
    } catch (error) {
      setAlert({
        type: "fail",
        message:
          error?.response?.data?.message || "Invalid OTP or expired session.",
      });
    }
  };

  const goToLoginScreen = () => {
  setIsOtpStep(false);
  setIsForgotPassword(false);
  setErrors({});
  setTimeout(() => {
    generateCaptcha(); 
    setCaptchaInput("");
  }, 100);
};

  return (
    <>
      <div className="login-page">
        <div className="row container-fluid m-0 p-0 vh-100">
          {/* Left side (form) */}
           <div className={`col-12 col-md-6 p-5 rounded-1 animate-fade d-flex flex-column ${!isOtpStep ? "justify-content-center flex-grow-1" : ""}`}>
            <div className="text-center">
              <Link to={"/"}>
                <img src="/HRSetu-final-logo.svg" alt="HRSetu" width={100} />
              </Link>

              {isForgotPassword ? (
                <>
                  <h4 className="text-center mt-5 animate-slide-in text-dark">
                    Forgot your Password?
                  </h4>
                  <p className="text-muted">
                    Enter your email and reset your password.
                  </p>
                </>
              ) : isOtpStep ? (
                <>
                  <h4 className="text-center animate-slide-in text-dark" style={{ marginTop: "150px" }}>
                    Enter OTP to Verify
                  </h4>
                  <p className="text-muted">
                    Please enter the OTP sent to your registered email.
                  </p>
                </>
              ) : (
                <>
                  <h4 className="text-center mt-5 animate-slide-in text-dark">
                    Login to your Consultant account
                  </h4>
                  <p className="text-muted">
                    Welcome back, please enter your details
                  </p>
                </>
              )}
            </div>

            {/* FORGOT PASSWORD */}
            {isForgotPassword ? (
              <form className="animate-form px-5 py-4">
                {/* Email */}
                <div className="mb-3">
                  <label className="form-label text-dark">Email address</label>
                  <input
                    type="email"
                    className="form-control rounded-3"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                {/* New Password */}
                <div className="mb-3">
                  <label className="form-label text-dark">New Password</label>
                  <div className="position-relative">
                    <span className="InputLogoSet mt-2">
                      <i className="bi bi-lock"></i>
                    </span>
                    <input
                      type={IsPasswordVisible ? "text" : "password"}
                      className="form-control rounded-3 ps-5"
                      placeholder="Enter new password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />

                    <a
                      className="text-dark eyeBtnSet"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsPasswordVisible(!IsPasswordVisible);
                      }}
                    >
                      {IsPasswordVisible ? (
                        <i className="bi bi-eye-slash"></i>
                      ) : (
                        <i className="bi bi-eye"></i>
                      )}
                    </a>
                  </div>
                </div>

                {/* Confirm Password */}
                <div className="mb-3">
                  <label className="form-label text-dark">
                    Confirm Password
                  </label>
                  <div className="position-relative">
                    <span className="InputLogoSet mt-2">
                      <i className="bi bi-lock"></i>
                    </span>
                    <input
                      type={IsPasswordVisible ? "text" : "password"}
                      className="form-control rounded-3 ps-5"
                      placeholder="Confirm new password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />

                    <a
                      className="text-dark eyeBtnSet"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsPasswordVisible(!IsPasswordVisible);
                      }}
                    >
                      {IsPasswordVisible ? (
                        <i className="bi bi-eye-slash"></i>
                      ) : (
                        <i className="bi bi-eye"></i>
                      )}
                    </a>
                  </div>
                </div>

                {/* Submit */}
                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn custom-btn"
                    onClick={() => {
                      if (!email.trim()) {
                        setAlert({
                          type: "fail",
                          message: "Email is required!",
                        });
                        return;
                      }

                      if (!newPassword.trim()) {
                        setAlert({
                          type: "fail",
                          message: "New Password is required!",
                        });
                        return;
                      }

                      if (!isStrongPassword(newPassword)) {
                        setAlert({
                          type: "fail",
                          message:
                            "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.",
                        });
                        return;
                      }

                      if (newPassword !== confirmPassword) {
                        setAlert({
                          type: "fail",
                          message: "Passwords do not match!",
                        });
                        return;
                      }

                      setAlert({
                        type: "success",
                        message: "Password reset successfully!",
                      });
                      goToLoginScreen();
                    }}
                  >
                    Submit
                  </button>

                  <div className="mt-3">
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={goToLoginScreen}
                    >
                      Back to Login
                    </button>
                  </div>
                </div>
              </form>
            ) : null}

            {/* LOGIN SCREEN*/}
            {!isForgotPassword && !isOtpStep && (
              <>
                <form className="animate-form px-5 py-4">
                {/* Email */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label text-dark">
                    Email address
                  </label>
                  <div className="position-relative">
                    <span className="InputLogoSet mt-2">
                      <i className="bi bi-envelope-open"></i>
                    </span>
                    <input
                      type="email"
                      id="email"
                      className={`form-control rounded-3 ps-5 ${
                        errors.email ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                    />
                    {errors.email && (
                      <div className="invalid-feedback">{errors.email}</div>
                    )}
                  </div>
                </div>

                {/* Password */}
                <div className="mb-3">
                  <label htmlFor="password" className="form-label text-dark">
                    Password
                  </label>
                  <div className="position-relative">
                    <span className="InputLogoSet mt-2">
                      <i className="bi bi-lock"></i>
                    </span>
                    <input
                      type={IsPasswordVisible ? "text" : "password"}
                      id="password"
                      className={`form-control rounded-3 ps-5 ${
                        errors.password ? "is-invalid" : ""
                      }`}
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={loading}
                    />
                    <a
                      className="text-dark eyeBtnSet"
                      onClick={(e) => {
                        e.preventDefault();
                        setIsPasswordVisible(!IsPasswordVisible);
                      }}
                    >
                      {IsPasswordVisible ? (
                        <i className="bi bi-eye-slash"></i>
                      ) : (
                        <i className="bi bi-eye"></i>
                      )}
                    </a>
                    {errors.password && (
                      <div className="invalid-feedback">{errors.password}</div>
                    )}
                  </div>
                </div>

                {/* Captcha */}
                <div className="mb-3">
                  <label className="form-label text-dark">
                    Verification Code
                  </label>

                  <div className="d-flex align-items-center">
                    {/* Canvas Captcha */}
                    <canvas
                      id="consultantCaptchaCanvas"
                      width="150"
                      height="45"
                      className="border rounded me-2"
                      style={{
                        backgroundColor: "#EAF4FF",
                        border: "1px solid #ccc",
                      }}
                    ></canvas>

                    {/* Refresh button */}
                    <button
                      type="button"
                      className="btn btn-link ms-2"
                      onClick={generateCaptcha}
                      disabled={loading}
                      style={{ color: "#004687" }}
                      title="Refresh Captcha"
                    >
                      <i className="bi bi-arrow-clockwise fs-5"></i>
                    </button>

                    {/* Captcha Input */}
                    <div className="w-75">
                      <input
                        type="text"
                        className={`form-control mt-2 ${
                          errors.captchaInput ? "is-invalid" : ""
                        }`}
                        placeholder="Enter Verification Code"
                        value={captchaInput}
                        onChange={(e) => setCaptchaInput(e.target.value)}
                        disabled={loading}
                      />
                      {errors.captchaInput && (
                        <div className="invalid-feedback">
                          {errors.captchaInput}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Forgot Password Link */}
                  <div className="text-end mt-3">
                    <button
                      className="btn btn-link p-0"
                      type="button"
                      onClick={() => setIsForgotPassword(true)}
                    >
                      Forgot Password?
                    </button>
                  </div>

                {/* Login Button */}
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn custom-btn mt-2"
                    onClick={handleLogin}
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Logging in...
                      </>
                    ) : (
                      "Login"
                    )}
                  </button>
                </div>
              </form>
              </>
            )}

            {/* OTP */}
            {isOtpStep && !isForgotPassword && (
              <form
                className="animate-form px-5 py-4"
                onSubmit={handleVerifyOtp}
              >
                <div className="mb-3">
                  <label className="form-label text-dark">Enter OTP</label>
                  <input
                    type={IsPasswordVisible ? "text" : "password"}
                    className="form-control rounded-3"
                    placeholder="Enter 6-digit OTP"
                    value={otpInput}
                    maxLength={6} 
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); 
                      setOtpInput(value);
                    }}
                  />
                </div>

                <div className="text-center mt-4">
                  <button type="submit" className="btn custom-btn">
                    Verify OTP
                  </button>
                </div>
              </form>
            )}
          </div>

          {/* Right side (image) */}
          <div className="col-12 col-md-6 text-center p-0 d-md-block d-none">
            <img src={LoginBg} alt="..login" className="login-image" />
          </div>
        </div>
      </div>

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default ConsultantLogin;
